import React from 'react';
import { Icon, Collapse as AntCollapse } from 'antd';
import cn from 'classnames';
import styles from './index.module.scss';

const sizes = Object.freeze({ sm: 'sm', lg: 'lg' });

const Collapse = ({ className, size = sizes.lg, ...props }) => {
  const validSize = sizes[size] ? size : sizes.lg;

  return (
    <AntCollapse
      {...props}
      className={cn(styles.root, styles[validSize], className)}
      bordered={false}
      expandIcon={Arrow}
    />
  );
};

Collapse.Panel = AntCollapse.Panel;

export default Collapse;

function Arrow({ isActive, className }) {
  return (
    <div className={cn(styles.arrowCover, className)}>
      <Icon
        type="caret-down"
        className={styles.arrow}
        rotate={isActive ? 180 : 0}
      />
    </div>
  );
}
